import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class OutpostSea2PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.OUTPOST_SEA2;
}

export default OutpostSea2PoiTileEntity;
